import { useAuthStore } from '~/@api/client/authStore'

export const useAuthenticated = () => {
  const { auth } = useAuthStore()

  return {
    hasAuthToken: auth != null,
  }
}
